import React, { useState } from 'react';
import Collapse from 'react-bootstrap/Collapse';
import Button from 'react-bootstrap/Button';
import ClockIcon from 'images/pu/products/usa_pcb_assembly/icons_clock.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretUp, faCaretDown } from '@fortawesome/free-solid-svg-icons'


const LeadTimeRestrictions = (props) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="leadtime-restrictions">
      <div className={`preview-content ${open ? 'expanded' : ''}`}>
        <div>
          <div className="restriction">
            <h5 className="title">
              QUICKTURN LEAD TIMES
            </h5>
            <div className="row">
              <div className="col-xs-12 col-md-4">
                <div className="title-leadtime">
                  24 Hour Turn
                </div>
                <ul>
                  <li>8 PCBs Maximum</li>
                  <li>Up to 15 BOM Line Items</li>
                  <li>Up to 70 SMT placements / board</li>
                </ul>
              </div>
              <div className="col-xs-12 col-md-4">
                <div className="title-leadtime">
                  48 Hour Turn
                </div>
                <ul>
                  <li>20 PCBs Maximum</li>
                  <li>Up to 20 BOM Line Items</li>
                  <li>Up to 150 SMT placements / board</li>
                </ul>
              </div>
              <div className="col-xs-12 col-md-4">
                <div className="title-leadtime">
                  5 Day Turn
                </div>
                <ul>
                  <li>100 PCBs Maximum</li>
                  <li>Up to 40 BOM Line Items</li>
                  <li>Up to 500 SMT placements / board</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Collapse in={open}>
        <div id="leadtime-collapse-content">
          <div>
            <div className="restriction">
              <h5 className="title">
                QUICKTURN LEAD TIMES
              </h5>
              <div className="row">
                <div className="col-xs-12 col-md-4">
                  <div className="title-leadtime">
                    24 Hour Turn
                  </div>
                  <ul>
                    <li>8 PCBs Maximum</li>
                    <li>Up to 15 BOM Line Items</li>
                    <li>Up to 70 SMT placements / board</li>
                    <li>Maximum of 8 Through Hole Components per Order</li>
                  </ul>
                </div>
                <div className="col-xs-12 col-md-4">
                  <div className="title-leadtime">
                    48 Hour Turn
                  </div>
                  <ul>
                    <li>20 PCBs Maximum</li>
                    <li>Up to 20 BOM Line Items</li>
                    <li>Up to 150 SMT placements / board</li>
                    <li>Maximum of 40 Through Hole Components per Order</li>
                  </ul>
                </div>
                <div className="col-xs-12 col-md-4">
                  <div className="title-leadtime">
                    5 Day Turn
                  </div>
                  <ul>
                    <li>100 PCBs Maximum</li>
                    <li>Up to 40 BOM Line Items</li>
                    <li>Up to 500 SMT placements / board</li>
                    <li>Maximum of 200 Through Hole Components per Order</li>
                  </ul>
                </div>
              </div>
            </div>
            <hr />
            <div className="restriction">
              <h5 className="title">
                STANDARD LEAD TIMES
              </h5>
              <div className="row">
                <div className="col-xs-12 col-md-4">
                  <div className="title-leadtime">
                    7 Day Turn
                  </div>
                  <ul>
                    <li>500 PCBs Maximum</li>
                    <li>Up to 70 BOM Line Items</li>
                    <li>Maximum of 500 Through Hole Components per Order</li>
                  </ul>
                </div>
                <div className="col-xs-12 col-md-4">
                  <div className="title-leadtime">
                    10 Day Turn
                  </div>
                  <ul>
                    <li>1000 PCBs Maximum</li>
                    <li>Up to 90 BOM Line Items</li>
                    <li>Maximum of 1000 Through Hole Components per Order</li>
                  </ul>
                </div>
                <div className="col-xs-12 col-md-4">
                  <div className="title-leadtime">
                    15 Day Turn
                  </div>
                  <ul>
                    <li>4000 PCBs Maximum</li>
                    <li>Up to 120 BOM Line Items</li>
                    <li>Maximum of 4000 Through Hole Components per Order</li>
                  </ul>
                </div>
              </div>
            </div>
            <p>
              <strong>
                Scheduled Shipments also Available for High Volume Production
              </strong>
            </p>
          </div>
          <div className="assembly-clock">
            <div className="container">
              <div className="d-flex align-items-center">
                <div>
                  <img src={ClockIcon} alt="Assembly Clock" />
                </div>
                <div>
                  The Assembly Clock starts ticking the day after the PCBs,
                  all the parts and required files are received.
                </div>
              </div>
            </div>
          </div>
        </div>
      </Collapse>

      <Button
        className="btn btn-secondary-clear btn-sm btn-toggle mt-2"
        onClick={() => setOpen(!open)}
        aria-controls="leadtime-collapse-content"
        aria-expanded={open}
      >
        {open ? 'Show Less' : 'Show More'}
        <FontAwesomeIcon className="ms-2" icon={open ? faCaretUp : faCaretDown} />
      </Button>
    </div>
  );
};

export default LeadTimeRestrictions;
